import React from 'react';
import { Coins, Lock, Globe, Zap } from 'lucide-react';

const features = [
  {
    icon: Coins,
    title: 'Digital Currency',
    description: 'Bitcoin is a decentralized digital currency that enables instant payments to anyone, anywhere in the world.'
  },
  {
    icon: Lock,
    title: 'Secure',
    description: 'Protected by advanced cryptography, making it one of the most secure forms of currency.'
  },
  {
    icon: Globe,
    title: 'Borderless',
    description: 'Send and receive Bitcoin globally without traditional banking restrictions.'
  },
  {
    icon: Zap,
    title: 'Fast Transactions',
    description: 'Transfer value quickly and efficiently, with transactions typically confirming within minutes.'
  }
];

export default function WhatIsBitcoin() {
  return (
    <section className="bg-gray-800/50 backdrop-blur-sm rounded-lg p-8">
      <h2 className="text-3xl font-bold text-white mb-6">What is Bitcoin?</h2>
      <p className="text-gray-300 mb-8">
        Bitcoin is the world's first decentralized cryptocurrency, operating on a peer-to-peer network 
        without the need for intermediaries. It enables direct transactions between users while maintaining 
        security through advanced cryptography.
      </p>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {features.map((feature, index) => (
          <div key={index} className="p-6 bg-gray-700/50 rounded-lg">
            <feature.icon className="w-8 h-8 text-purple-500 mb-4" />
            <h3 className="text-xl font-semibold text-white mb-2">{feature.title}</h3>
            <p className="text-gray-400">{feature.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
}